module.exports = __webpack_public_path__ + "img/services-reservations.d4d7ed46.svg";